<div class="range-step">
  <section class="range-step__card">
    <h2 class="range-step__title">Scegli lotto</h2>

    <div class="range-step__values">
      <label class="range-step__value range-step__value--full">
        <span>Lotto</span>
        <input
          type="text"
          class="range-step__input"
          aria-label="Lotto"
          [ngModel]="newBatchToUpload.manual_batch"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="updateManualBatch($event)"
        />
      </label>

      <label class="range-step__value">
        <span>Quantità disponibile</span>
        <div class="range-step__input">{{ getMaximum }}pz</div>
      </label>

      <label class="range-step__value">
        <span>Quantità</span>
        <input
          type="text"
          inputmode="numeric"
          class="range-step__input"
          aria-label="Quantità"
          [ngModel]="newBatchToUpload.qta"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="updateQuantity($event)"
          [min]="getMinimum"
        />
      </label>
    </div>
  </section>
</div>
